import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import FloatingButton from "../../Material/FloatingButton";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Moment from "react-moment";
import XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { apiFetch } from "../../../apiFetch";

toast.configure();
class Accessprivilegelist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listArray: [],
      accesslistitem: [],
      deletePopup: false,
      deleteId: "",
      loading: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
      firstrowhighlight: null,
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: "headerTitle", value: "Access Privilege" });
    this.GetListData();
    const checkhightlight = localStorage.getItem("firststatus");
    {
      checkhightlight === "yes"
        ? this.setState({
            firstrowhighlight: "firstlinehighlight tbody tr:first-child",
          })
        : this.setState({ firstrowhighlight: null });
    }

    setTimeout(() => {
      this.setState({ firstrowhighlight: null });
      localStorage.setItem("firststatus", "no");
    }, 5000);
  }

  GetListData = (val) => {
    // alert('a')
    let postData = { ID: "0" };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetAccessPrivileges",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        console.log(data);
        if (data) {
          this.setState({ accesslistitem: data.PrivilegeList, loading: "Yes" });
          // console.log("have to check"+JSON.stringify(this.state.accesslistitem))
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  deleteRecord = (id) => {
    this.setState({ deletePopup: true, deleteId: id });
  };

  cancelDelete = () => {
    this.setState({ deletePopup: false, deleteId: "" });
  };

  confirmDelete = () => {
    this.setState({ deletePopup: false });
    let postData = { ID: this.state.deleteId, Mode: "Delete" };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/InsertUpdateAccessPrivileges",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          if (data.Status === "Success") {
            this.GetListData();
            this.setState({ deleteId: "" });
            toast.success("Deleted successfully.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          } else {
            toast.error(data.Message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  edit = (id) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/Access/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(id),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "Role",
        header2: "Employee ID ",
        header3: "Name",
        header4: "Cost Center/Dept",
        header5: "Custodian",
        header6: "Created By",
        header7: "Created Date & Time",
        header8: "Modified by",
        header9: "Modified Date",
        header10: "Status",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            value.data[5],
            value.data[6],
            value.data[7],
            value.data[8],
            value.data[9],
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.accesslistitem.forEach((value, index) => {
          let mdData = [
            value.Role,
            value.EmployeeID,
            value.EmployeeName,
            value.CostCenter,
            value.Custodian,
            value.CreatedBy
              ? value.CreatedBy + " (" + value.CreatedByName + ")"
              : "Null",
            value.CreatedDate
              ? moment(value.CreatedDate).format("DD-MM-yyyy HH:mm:ss")
              : "",
            value.ModifiedBy
              ? value.ModifiedBy + " (" + value.ModifiedByName + ")"
              : "Null",
            value.ModifiedDate
              ? moment(value.ModifiedDate).format("DD-MM-yyyy HH:mm:ss")
              : "",
            value.Active,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "Access Privilege.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  render() {
    let dataArray = [];
    this.state.accesslistitem.map((data) => {
      let mdData = [
        data.Role,
        data.EmployeeID,
        data.EmployeeName,
        data.CostCenter,
        data.Custodian,
        data.CreatedBy
          ? data.CreatedBy + " (" + data.CreatedByName + ")"
          : "Null",
        data.CreatedDate
          ? moment(data.CreatedDate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        data.ModifiedBy
          ? data.ModifiedBy + " (" + data.ModifiedByName + ")"
          : "Null",
        data.ModifiedDate
          ? moment(data.ModifiedDate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        data.Active,
        data.Active,
        data.Id,
      ];
      dataArray.push(mdData);
      return null;
    });

    const columns = [
      {
        name: "Role",
        label: "Role",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "EmployeeID",
        label: "Employee ID",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "EmployeeName",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CostCenter",
        label: "Cost Center/Dept",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Custodian",
        label: "Custodian",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <div className="customcustodian">{value}</div>
              </>
            );
          },
        },
      },
      {
        name: "CreatedBy",
        label: "Created By",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "CreatedDate",
        label: "Created Date Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "ModifiedBy",
        label: "Modified by",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "ModifiedDate",
        label: "Modified Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: false,
          display: false,
          viewColumns: false,
        },
        editable: true,
      },
      {
        name: "Status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                {value === "Active" ? (
                  <div className="badge badge-approved">{value}</div>
                ) : (
                  <div className="badge badge-rejected">{value}</div>
                )}
              </>
            );
          },
        },
      },
      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            //  console.log(value.ID)
            return (
              <>
                <ReactTooltip />
                <img
                  className="action-right-space mouse-pointer"
                  style={{ width: "25px" }}
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/edit-solid.svg"
                  }
                  data-tip="Edit"
                  onClick={() => this.edit(value)}
                />

                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/ionic-md-close.svg"
                  }
                  data-tip="Delete"
                  alt="Close"
                  onClick={() => this.deleteRecord(value)}
                />
              </>
            );
          },
        },
      },
    ];
    const options = {
      filterType: "checkbox",
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}>
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
          </>
        );
      },
    };

    return (
      <>
        <Modal show={this.state.deletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmDelete}>
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Access Privilege</Breadcrumb.Item>
        </Breadcrumb>

        <div className="text-right mb-3">
          <Link to="/Access/create">
            <button type="button" className="btn btn-primary">
              {" "}
              + Add
            </button>
          </Link>
        </div>
        <MUIDataTable
          title={""}
          data={dataArray}
          columns={columns}
          options={options}
          className={`${this.state.firstrowhighlight}`}
        />
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(Accessprivilegelist);
